import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSelectingSomethingOtherThanGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../app/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../../settings/services/ServerSettingsUnauthenticated';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { siteUserResetLoginRateLimiting } from '../actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserResetLoginRateLimitingAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserResetLoginRateLimiting,
  translateName: Messages.resetLoginRateLimiting_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return FeatureFlags.localAuthLoginRateLimitingEnabled && ServerSettingsUnauthenticated.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return isSelectingSomethingOtherThanGuest(targetItems);
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserResetLoginRateLimiting(targetItems)
};
